module.exports = __webpack_public_path__ + "img/handbook-explosion_jp.4a1973f.jpg";